import React from 'react';
import { Route } from 'react-router-dom';

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    component: Component,
    name,
    menuId,
    accessFunction,
    componentProps,
    ...rest
  } = props;

  if (typeof accessFunction === 'function') {
    accessFunction(name);
  }
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(matchProps) => (
        <Layout currentPage={name} menuId={menuId}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Component {...matchProps} currentPage={name} menuId={menuId} {...componentProps} />
        </Layout>
      )}
    />
  );
};

export default RouteWithLayout;
